var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7675 23.5455H9.94737V8.69701H21.7675V23.5455ZM21.7675 6.5758H9.94737C9.37739 6.5758 8.83075 6.79928 8.42771 7.19709C8.02467 7.59489 7.79825 8.13443 7.79825 8.69701V23.5455C7.79825 24.1081 8.02467 24.6476 8.42771 25.0454C8.83075 25.4432 9.37739 25.6667 9.94737 25.6667H21.7675C22.3375 25.6667 22.8842 25.4432 23.2872 25.0454C23.6902 24.6476 23.9167 24.1081 23.9167 23.5455V8.69701C23.9167 8.13443 23.6902 7.59489 23.2872 7.19709C22.8842 6.79928 22.3375 6.5758 21.7675 6.5758ZM18.5439 2.33337H5.64912C5.07914 2.33337 4.5325 2.55686 4.12946 2.95466C3.72642 3.35247 3.5 3.89201 3.5 4.45459V19.3031H5.64912V4.45459H18.5439V2.33337Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.d39a5581eb4889003bb28652262602a8.svg";
export { ForwardRef as ReactComponent };